import { AudioSfx } from '../../../learn/constants/sfx.ts';

import { PreloadableAsset, PreloadableAssetType } from '../../types/asset/preloading.types.ts';

export class AudioSfxProviderUtil {
  private static _instance: AudioSfxProviderUtil;
  private sfxMap: Record<AudioSfx, string> | null = null;

  private constructor() {
    this.initSfxMap();
  }

  private async initSfxMap(): Promise<void> {
    this.sfxMap = {
      [AudioSfx.BUBBLE_APPEAR]: await this.loadSfx(AudioSfx.BUBBLE_APPEAR),
      [AudioSfx.BUBBLE_POP]: await this.loadSfx(AudioSfx.BUBBLE_POP),
      [AudioSfx.BUBBLE_REDUCE]: await this.loadSfx(AudioSfx.BUBBLE_REDUCE),
      [AudioSfx.BUBBLE_WEAKEN]: await this.loadSfx(AudioSfx.BUBBLE_WEAKEN),
    };
  }

  private async loadSfx(sfx: AudioSfx): Promise<string> {
    const audio = (await import(`../../../learn/assets/audios/sfx/${sfx}.mp3`)).default as string;
    return audio;
  }

  public static get instance(): AudioSfxProviderUtil {
    if (!AudioSfxProviderUtil._instance) {
      AudioSfxProviderUtil._instance = new AudioSfxProviderUtil();
    }
    return AudioSfxProviderUtil._instance;
  }

  public getSfx(sfx: AudioSfx): string | null {
    return this.sfxMap?.[sfx] ?? null;
  }

  private async getSfxAsset(sfx: AudioSfx): Promise<PreloadableAsset> {
    return {
      type: PreloadableAssetType.Audio,
      url: await this.loadSfx(sfx),
    };
  }

  public async getCriticalAssets(): Promise<PreloadableAsset[]> {
    const criticalSfx = [AudioSfx.BUBBLE_APPEAR, AudioSfx.BUBBLE_REDUCE];
    return await Promise.all(criticalSfx.map(this.getSfxAsset.bind(this)));
  }

  public async getAssets(): Promise<PreloadableAsset[]> {
    return await Promise.all(Object.values(AudioSfx).map(this.getSfxAsset.bind(this)));
  }
}

export const getAudioSfxProviderUtil = (): AudioSfxProviderUtil => AudioSfxProviderUtil.instance;
